import { Grid, Typography, useTheme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../app/routes";
import { Teacher } from "@app/shared/types";
import DocumentContext from "components/DocumentContext";
import LoadingBar from "components/LoadingBar";
import PageWrapper from "components/PageWrapper";
import { NavLink } from "../navigation/NavLink";
import {
    fetchTeachers,
    selectTeachers,
    selectTeachersHaveLoaded,
    selectTeachersIsLoading,
} from "./communitySlice";
import { TeacherCard } from "./TeacherCard";
import TeacherDialog from "./TeacherDialog";
import { BRAND_NAME } from "@app/shared/constants";
import { LinkButton } from "features/navigation/LinkButton";

const useStyles = makeStyles((theme) => ({
    root: {},
}));

export const CommunityPage = () => {
    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();

    const teachers = (useSelector(selectTeachers) || []) as Teacher[];
    const teachersRandomized = ([] as Teacher[]).concat(teachers).sort(() => Math.random() - 0.5);
    const teachersLoaded = useSelector(selectTeachersHaveLoaded);
    const teachersLoading = useSelector(selectTeachersIsLoading);

    const [teacherDialogTeacher, setTeacherDialogTeacher] = useState(null as Teacher | null);

    useEffect(() => {
        if (!teachersLoaded) {
            dispatch(fetchTeachers({}));
        }
    }, [teachersLoaded, dispatch]);

    return (
        <PageWrapper className={classes.root}>
            <DocumentContext title="Our community" />
            <TeacherDialog
                teacher={teacherDialogTeacher}
                open={teacherDialogTeacher !== null}
                onClose={() => setTeacherDialogTeacher(null)}
            />

            <Typography variant="overline">Who we are</Typography>
            <Typography variant="h2">Our community</Typography>
            <Typography variant="h3">Our mindfulness groups</Typography>
            <Typography variant="body1">
                {BRAND_NAME} mentorship groups are led by highly trained meditation teachers who
                bring in decades of experience in mindfulness practice. We have groups for different
                experience levels of meditators, as well as for specific communities such as women
                and people of color.
            </Typography>
            <Typography variant="body1">
                <NavLink to={routes.faq()}>Learn more about our groups</NavLink>
            </Typography>
            <Typography variant="h3">Our teachers</Typography>
            <Typography variant="body1">
                Our teachers bring decades of experience in meditative practice and years of
                extensive training in teaching mindfulness and facilitating online and offline
                groups. Our teachers have all been trained by world-class instructors such as Jack
                Kornfield and Tara Brach, two globally renowned mindfulness meditation teachers who
                helped bring mindfulness meditation to the West.
            </Typography>

            {teachersLoading && <LoadingBar />}
            <Grid container spacing={4}>
                {teachersRandomized &&
                    teachersRandomized
                        .sort(() => Math.random() - 0.5)
                        .map((teacher, i) => (
                            <TeacherCard
                                key={i}
                                teacher={teacher}
                                onOpenProfile={() => setTeacherDialogTeacher(teacher)}
                            />
                        ))}
            </Grid>
            <LinkButton to={routes.join()} style={{ marginTop: theme.spacing(4) }}>
                Join our community
            </LinkButton>
        </PageWrapper>
    );
};

export default CommunityPage;
